import type { KeyData } from '@/features/charts/types/chartData';
import type { TemplateChartSeries } from '@/shared/types/charts';

export function findSeriesBasedOnKey(
  templateChartSeries: TemplateChartSeries[] | undefined,
  key: KeyData
) {
  return templateChartSeries?.find(series => {
    const k = series.symbol.key;
    return (
      k.Code === key.Code &&
      k.PeriodType === key.PeriodType &&
      k.Period === key.Period &&
      k.TimeRef === key.TimeRef
    );
  });
}
